import { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  Edit,
  Trash2,
  FolderTree,
} from "lucide-react";
import { CDN } from "../../redux/helpers/urlConfig";

export default function CategoryList({ categories = [], onEdit, onDelete }) {
  return (
    <div className="space-y-3">
      {categories.length > 0 ? (
        categories
          .filter((c) => c.parentId === null)
          .map((cat) => (
            <CategoryNode
              key={cat.id}
              category={cat}
              level={0}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))
      ) : (
        <div className="text-center text-slate-500">No categories found.</div>
      )}
    </div>
  );
}

function CategoryNode({ category, level, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);
  const hasChildren = category.children?.length > 0;

  return (
    <div
      className={`${
        level === 0
          ? "rounded-xl bg-white ring-1 ring-slate-200 px-2"
          : "rounded-xl bg-white ring-1 ring-slate-200"
      }`}
    >
      {/* Header */}
      <div
        className="flex items-center gap-3 px-4 py-3"
        style={{ paddingLeft: `${level * 24 + 16}px` }}
      >
        {/* Expand icon */}
        {hasChildren ? (
          <button onClick={() => setOpen(!open)}>
            {open ? (
              <ChevronDown className="h-4 w-4 text-slate-500" />
            ) : (
              <ChevronRight className="h-4 w-4 text-slate-500" />
            )}
          </button>
        ) : (
          <span className="w-4" />
        )}

        <FolderTree className="h-4 w-4 text-slate-600" />

        {/* Image */}
        {category.image && (
          <img
            src={`${CDN}${category.image.path}`}
            alt={category.name}
            className="h-8 w-8 rounded-lg"
          />
        )}

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="font-medium text-slate-900">{category.name}</div>
          {category.description && (
            <div className="text-xs text-slate-500 truncate">
              {category.description}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit?.(category)}
            className="rounded-lg p-2 hover:bg-slate-100"
          >
            <Edit className="h-4 w-4 text-slate-600" />
          </button>
          <button
            onClick={() => onDelete?.(category)}
            className="rounded-lg p-2 hover:bg-rose-50"
          >
            <Trash2 className="h-4 w-4 text-rose-600" />
          </button>
        </div>
      </div>

      {/* Children */}
      {open && hasChildren && (
        <div className="pb-2">
          {category.children.map((child) => (
            <CategoryNode
              key={child.id}
              category={child}
              level={level + 1}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
}
